import { colors } from './colors'
import { desktopFontSizes, fontSizes } from './fontSizes'
import { styles } from './styles'

export const theme = {
  colors,
  desktopFontSizes,
  dimensions: {
    widths: {
      borders: [0.25, 0.5, 1, 2, 4],
    },
  },
  fontSizes,
  styles,
}
